import * as x from "react";
import c, { useState as D, useCallback as q, useRef as M, useEffect as F, useMemo as P, Suspense as zr } from "react";
import { useFragment as Lr, usePreloadedQuery as Er, useQueryLoader as Or } from "react-relay";
import { u as R, p as Pr } from "./contexts-B3XPdR-g.mjs";
import { g as Nr } from "./index-DUTDaDpU.mjs";
import { html as pe } from "common-tags";
import { a as Ar, n as J, s as Fr, d as Mr, j as jr, i as Dr, g as Hr } from "./index-B2su9LGZ.mjs";
import { a as Z, g as $r } from "./environment-CeNBNzOW.mjs";
import { a as te, r as de } from "./fallback-storage-value-DpM7zNd8.mjs";
import { d as W } from "./tracking-impression-event-ZV5D7zg4.mjs";
import { t as _ } from "./breakpoints-DvaoDEis.mjs";
import { u as ae } from "./hooks-CVctWTPX.mjs";
import { n as f, s as Gr, o as Kr, N as Ur, V as Br, j as K, p as Qr, i as ne, h as St, f as It, e as j, S as Wr, q as Vr, r as Yr, t as Zr, v as Jr, B as Xr, w as ea, x as ta, y as na, d as U, z as ra } from "./index-BI7B57aQ.mjs";
import { Modal as aa } from "@mui/material";
import { Z as ia } from "./z-index-CEuzp1gH.mjs";
import { b as B, f as z, a as oa } from "./variables-BSQ2K9t-.mjs";
import V from "qs";
import { css as re } from "@emotion/react";
import sa, { Element as la } from "html-react-parser";
import * as Gt from "@product/scmp-account-sdk";
const sr = /* @__PURE__ */ function() {
  var e = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  }, {
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "id",
    storageKey: null
  }];
  return {
    fragment: {
      argumentDefinitions: [],
      kind: "Fragment",
      metadata: null,
      name: "displayAcquisitionPopupContainerQuery",
      selections: [{
        args: null,
        kind: "FragmentSpread",
        name: "hooksUseAcquisitionPopupQuery"
      }],
      type: "Query",
      abstractKey: null
    },
    kind: "Request",
    operation: {
      argumentDefinitions: [],
      kind: "Operation",
      name: "displayAcquisitionPopupContainerQuery",
      selections: [{
        alias: "pptoConfig",
        args: [{
          kind: "Literal",
          name: "filter",
          value: {
            entityId: "scmp_pwa_ppto"
          }
        }],
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: e,
        storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_ppto"})'
      }, {
        alias: "settings",
        args: [{
          kind: "Literal",
          name: "filter",
          value: {
            entityId: "scmp_pwa_settings"
          }
        }],
        concreteType: "AppConfig",
        kind: "LinkedField",
        name: "appConfig",
        plural: !1,
        selections: e,
        storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_settings"})'
      }]
    },
    params: {
      cacheID: "7baacf5c66135b8e20ec68cb94e5e709",
      id: null,
      metadata: {},
      name: "displayAcquisitionPopupContainerQuery",
      operationKind: "query",
      text: `query displayAcquisitionPopupContainerQuery {
  ...hooksUseAcquisitionPopupQuery
}

fragment hooksUseAcquisitionPopupQuery on Query {
  pptoConfig: appConfig(filter: {entityId: "scmp_pwa_ppto"}) {
    json
    id
  }
  settings: appConfig(filter: {entityId: "scmp_pwa_settings"}) {
    json
    id
  }
}
`
    }
  };
}();
sr.hash = "3ff4df315a1765e4d99b01b77df32294";
let G = /* @__PURE__ */ function(e) {
  return e.AcquisitionNewsletter = "acquisition-newsletter", e.Campaign = "campaign", e.MyNewsCompletion = "my-news-completion", e.TopicPackageFollow = "topic-package-follow", e.WhyRegister = "why-register", e;
}({});
const ca = (e) => (e + 1) % Number.MAX_SAFE_INTEGER;
function ua() {
  const [, e] = D(0);
  return q(() => {
    e(ca);
  }, []);
}
const pa = (e) => {
  e && clearTimeout(e);
};
function lr(e, t) {
  const n = te(e), r = te(t), i = M(null), a = q(() => {
    pa(i.current);
  }, []), o = q(() => {
    r.current !== void 0 && (a(), i.current = setTimeout(() => {
      n.current();
    }, r.current));
  }, []);
  return F(() => (o(), a), [t]), [a, o];
}
function da(e) {
  const t = te(e), n = M(de(t.current)), r = ua(), i = P(() => ({
    set(a) {
      n.current = de(a, n.current), r();
    },
    push(...a) {
      i.set((o) => [...o, ...a]);
    },
    updateAt(a, o) {
      i.set((s) => {
        const l = [...s];
        return l[a] = o, l;
      });
    },
    insertAt(a, o) {
      i.set((s) => {
        const l = [...s];
        return a >= l.length ? l[a] = o : l.splice(a, 0, o), l;
      });
    },
    update(a, o) {
      i.set((s) => s.map((l) => a(l, o) ? o : l));
    },
    updateFirst(a, o) {
      const s = n.current.findIndex((p) => a(p, o));
      s > -1 && i.updateAt(s, o);
    },
    upsert(a, o) {
      const s = n.current.findIndex((p) => a(p, o));
      s > -1 ? i.updateAt(s, o) : i.push(o);
    },
    sort(a) {
      i.set((o) => [...o].sort(a));
    },
    filter(a, o) {
      i.set((s) => [...s].filter(a, o));
    },
    removeAt(a) {
      i.set((o) => {
        const s = [...o];
        return a < s.length && s.splice(a, 1), s;
      });
    },
    clear() {
      i.set([]);
    },
    reset() {
      i.set([...de(t.current)]);
    }
  }), [t, r]);
  return [n.current, i];
}
const cr = /* @__PURE__ */ function() {
  var e = [{
    alias: null,
    args: null,
    kind: "ScalarField",
    name: "json",
    storageKey: null
  }];
  return {
    argumentDefinitions: [],
    kind: "Fragment",
    metadata: null,
    name: "hooksUseAcquisitionPopupQuery",
    selections: [{
      alias: "pptoConfig",
      args: [{
        kind: "Literal",
        name: "filter",
        value: {
          entityId: "scmp_pwa_ppto"
        }
      }],
      concreteType: "AppConfig",
      kind: "LinkedField",
      name: "appConfig",
      plural: !1,
      selections: e,
      storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_ppto"})'
    }, {
      alias: "settings",
      args: [{
        kind: "Literal",
        name: "filter",
        value: {
          entityId: "scmp_pwa_settings"
        }
      }],
      concreteType: "AppConfig",
      kind: "LinkedField",
      name: "appConfig",
      plural: !1,
      selections: e,
      storageKey: 'appConfig(filter:{"entityId":"scmp_pwa_settings"})'
    }],
    type: "Query",
    abstractKey: null
  };
}();
cr.hash = "3317539a3689a9bba9a7319d54f6cc94";
const ga = {
  button: {
    inMyNewsText: "START READING",
    otherPageText: pe`Go to <i style="font-weight: 400;">my</i><b>NEWS</b>`
  },
  description: pe`
    You can now
    <ul>
      <li>access your <b>Daily 5</b> must-read articles</li>
      <li>
        access <i style="font-weight: 400;">my</i><b>NEWS</b> via the <b>SCMP app</b>. <wbr />Simply
        <download-link>download</download-link> and log in
      </li>
    </ul>
  `,
  headline: pe`<i style="font-weight: 400;">my</i><b>NEWS</b> set-up is complete`,
  localStorageKey: "isShownMyNewsCompletionPopup"
}, fa = {
  completion: ga
}, ma = (e, t) => {
  var n, r;
  const {
    acquisition: {
      setPopupState: i
    }
  } = R(), a = Lr(cr, t);
  F(() => {
    var o, s;
    if (!(a != null && (o = a.pptoConfig) !== null && o !== void 0 && o.json) || !(a != null && (s = a.settings) !== null && s !== void 0 && s.json)) return;
    const l = {
      ...a.pptoConfig.json,
      ...a.settings.json
    }, p = Object.entries(l).reduce((d, [b, g]) => {
      const m = b.toUpperCase();
      return m.startsWith("ACQUISITION_NL_") ? d.acquisitions[b] = g : m.startsWith("ACQUISITION_WHY_REGISTER_") ? d.whyRegister[b] = g : m.startsWith("CAMPAIGN_POPUP_") ? d.campaigns[b] = g : m.startsWith("TOPIC_PACKAGE_FOLLOW_POPUP_") && (d.topicPackageFollows[b] = g), d;
    }, {
      acquisitions: {},
      campaigns: {},
      myNews: {
        config: l == null ? void 0 : l.my_news,
        ...fa
      },
      topicPackageFollows: {},
      whyRegister: {}
    });
    i(p);
  }, [a == null || (n = a.pptoConfig) === null || n === void 0 ? void 0 : n.json, a == null || (r = a.settings) === null || r === void 0 ? void 0 : r.json, i]);
};
var ge, Kt;
function ur() {
  if (Kt) return ge;
  Kt = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, a = Array(i); ++r < i; )
      a[r] = n(t[r], r, t);
    return a;
  }
  return ge = e, ge;
}
var fe, Ut;
function ha() {
  if (Ut) return fe;
  Ut = 1;
  var e = typeof Z == "object" && Z && Z.Object === Object && Z;
  return fe = e, fe;
}
var me, Bt;
function Ft() {
  if (Bt) return me;
  Bt = 1;
  var e = ha(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return me = n, me;
}
var he, Qt;
function pr() {
  if (Qt) return he;
  Qt = 1;
  var e = Ft(), t = e.Symbol;
  return he = t, he;
}
var ye, Wt;
function ya() {
  if (Wt) return ye;
  Wt = 1;
  var e = pr(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function a(o) {
    var s = n.call(o, i), l = o[i];
    try {
      o[i] = void 0;
      var p = !0;
    } catch {
    }
    var d = r.call(o);
    return p && (s ? o[i] = l : delete o[i]), d;
  }
  return ye = a, ye;
}
var ve, Vt;
function va() {
  if (Vt) return ve;
  Vt = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return ve = n, ve;
}
var _e, Yt;
function _a() {
  if (Yt) return _e;
  Yt = 1;
  var e = pr(), t = ya(), n = va(), r = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? i : r : a && a in Object(s) ? t(s) : n(s);
  }
  return _e = o, _e;
}
var be, Zt;
function dr() {
  if (Zt) return be;
  Zt = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return be = e, be;
}
var xe, Jt;
function gr() {
  if (Jt) return xe;
  Jt = 1;
  var e = _a(), t = dr(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function o(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == i || l == n || l == a;
  }
  return xe = o, xe;
}
var we, Xt;
function ba() {
  if (Xt) return we;
  Xt = 1;
  var e = Ft(), t = e["__core-js_shared__"];
  return we = t, we;
}
var Ce, en;
function xa() {
  if (en) return Ce;
  en = 1;
  var e = ba(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return Ce = n, Ce;
}
var ke, tn;
function wa() {
  if (tn) return ke;
  tn = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return ke = n, ke;
}
var Se, nn;
function Ca() {
  if (nn) return Se;
  nn = 1;
  var e = gr(), t = xa(), n = dr(), r = wa(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, l = o.toString, p = s.hasOwnProperty, d = RegExp(
    "^" + l.call(p).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function b(g) {
    if (!n(g) || t(g))
      return !1;
    var m = e(g) ? d : a;
    return m.test(r(g));
  }
  return Se = b, Se;
}
var Ie, rn;
function ka() {
  if (rn) return Ie;
  rn = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return Ie = e, Ie;
}
var qe, an;
function Mt() {
  if (an) return qe;
  an = 1;
  var e = Ca(), t = ka();
  function n(r, i) {
    var a = t(r, i);
    return e(a) ? a : void 0;
  }
  return qe = n, qe;
}
var Te, on;
function ie() {
  if (on) return Te;
  on = 1;
  var e = Mt(), t = e(Object, "create");
  return Te = t, Te;
}
var Re, sn;
function Sa() {
  if (sn) return Re;
  sn = 1;
  var e = ie();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Re = t, Re;
}
var ze, ln;
function Ia() {
  if (ln) return ze;
  ln = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return ze = e, ze;
}
var Le, cn;
function qa() {
  if (cn) return Le;
  cn = 1;
  var e = ie(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    if (e) {
      var s = o[a];
      return s === t ? void 0 : s;
    }
    return r.call(o, a) ? o[a] : void 0;
  }
  return Le = i, Le;
}
var Ee, un;
function Ta() {
  if (un) return Ee;
  un = 1;
  var e = ie(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : n.call(a, i);
  }
  return Ee = r, Ee;
}
var Oe, pn;
function Ra() {
  if (pn) return Oe;
  pn = 1;
  var e = ie(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var a = this.__data__;
    return this.size += this.has(r) ? 0 : 1, a[r] = e && i === void 0 ? t : i, this;
  }
  return Oe = n, Oe;
}
var Pe, dn;
function za() {
  if (dn) return Pe;
  dn = 1;
  var e = Sa(), t = Ia(), n = qa(), r = Ta(), i = Ra();
  function a(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++s < l; ) {
      var p = o[s];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Pe = a, Pe;
}
var Ne, gn;
function La() {
  if (gn) return Ne;
  gn = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Ne = e, Ne;
}
var Ae, fn;
function Ea() {
  if (fn) return Ae;
  fn = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return Ae = e, Ae;
}
var Fe, mn;
function oe() {
  if (mn) return Fe;
  mn = 1;
  var e = Ea();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return Fe = t, Fe;
}
var Me, hn;
function Oa() {
  if (hn) return Me;
  hn = 1;
  var e = oe(), t = Array.prototype, n = t.splice;
  function r(i) {
    var a = this.__data__, o = e(a, i);
    if (o < 0)
      return !1;
    var s = a.length - 1;
    return o == s ? a.pop() : n.call(a, o, 1), --this.size, !0;
  }
  return Me = r, Me;
}
var je, yn;
function Pa() {
  if (yn) return je;
  yn = 1;
  var e = oe();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return je = t, je;
}
var De, vn;
function Na() {
  if (vn) return De;
  vn = 1;
  var e = oe();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return De = t, De;
}
var He, _n;
function Aa() {
  if (_n) return He;
  _n = 1;
  var e = oe();
  function t(n, r) {
    var i = this.__data__, a = e(i, n);
    return a < 0 ? (++this.size, i.push([n, r])) : i[a][1] = r, this;
  }
  return He = t, He;
}
var $e, bn;
function Fa() {
  if (bn) return $e;
  bn = 1;
  var e = La(), t = Oa(), n = Pa(), r = Na(), i = Aa();
  function a(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++s < l; ) {
      var p = o[s];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, $e = a, $e;
}
var Ge, xn;
function Ma() {
  if (xn) return Ge;
  xn = 1;
  var e = Mt(), t = Ft(), n = e(t, "Map");
  return Ge = n, Ge;
}
var Ke, wn;
function ja() {
  if (wn) return Ke;
  wn = 1;
  var e = za(), t = Fa(), n = Ma();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Ke = r, Ke;
}
var Ue, Cn;
function Da() {
  if (Cn) return Ue;
  Cn = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return Ue = e, Ue;
}
var Be, kn;
function se() {
  if (kn) return Be;
  kn = 1;
  var e = Da();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return Be = t, Be;
}
var Qe, Sn;
function Ha() {
  if (Sn) return Qe;
  Sn = 1;
  var e = se();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return Qe = t, Qe;
}
var We, In;
function $a() {
  if (In) return We;
  In = 1;
  var e = se();
  function t(n) {
    return e(this, n).get(n);
  }
  return We = t, We;
}
var Ve, qn;
function Ga() {
  if (qn) return Ve;
  qn = 1;
  var e = se();
  function t(n) {
    return e(this, n).has(n);
  }
  return Ve = t, Ve;
}
var Ye, Tn;
function Ka() {
  if (Tn) return Ye;
  Tn = 1;
  var e = se();
  function t(n, r) {
    var i = e(this, n), a = i.size;
    return i.set(n, r), this.size += i.size == a ? 0 : 1, this;
  }
  return Ye = t, Ye;
}
var Ze, Rn;
function Ua() {
  if (Rn) return Ze;
  Rn = 1;
  var e = ja(), t = Ha(), n = $a(), r = Ga(), i = Ka();
  function a(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++s < l; ) {
      var p = o[s];
      this.set(p[0], p[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Ze = a, Ze;
}
var Je, zn;
function Ba() {
  if (zn) return Je;
  zn = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return Je = t, Je;
}
var Xe, Ln;
function Qa() {
  if (Ln) return Xe;
  Ln = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Xe = e, Xe;
}
var et, En;
function Wa() {
  if (En) return et;
  En = 1;
  var e = Ua(), t = Ba(), n = Qa();
  function r(i) {
    var a = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < o; )
      this.add(i[a]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, et = r, et;
}
var tt, On;
function Va() {
  if (On) return tt;
  On = 1;
  function e(t, n, r, i) {
    for (var a = t.length, o = r + (i ? 1 : -1); i ? o-- : ++o < a; )
      if (n(t[o], o, t))
        return o;
    return -1;
  }
  return tt = e, tt;
}
var nt, Pn;
function Ya() {
  if (Pn) return nt;
  Pn = 1;
  function e(t) {
    return t !== t;
  }
  return nt = e, nt;
}
var rt, Nn;
function Za() {
  if (Nn) return rt;
  Nn = 1;
  function e(t, n, r) {
    for (var i = r - 1, a = t.length; ++i < a; )
      if (t[i] === n)
        return i;
    return -1;
  }
  return rt = e, rt;
}
var at, An;
function Ja() {
  if (An) return at;
  An = 1;
  var e = Va(), t = Ya(), n = Za();
  function r(i, a, o) {
    return a === a ? n(i, a, o) : e(i, t, o);
  }
  return at = r, at;
}
var it, Fn;
function Xa() {
  if (Fn) return it;
  Fn = 1;
  var e = Ja();
  function t(n, r) {
    var i = n == null ? 0 : n.length;
    return !!i && e(n, r, 0) > -1;
  }
  return it = t, it;
}
var ot, Mn;
function ei() {
  if (Mn) return ot;
  Mn = 1;
  function e(t, n, r) {
    for (var i = -1, a = t == null ? 0 : t.length; ++i < a; )
      if (r(n, t[i]))
        return !0;
    return !1;
  }
  return ot = e, ot;
}
var st, jn;
function ti() {
  if (jn) return st;
  jn = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return st = e, st;
}
var lt, Dn;
function ni() {
  if (Dn) return lt;
  Dn = 1;
  function e(t, n) {
    return t.has(n);
  }
  return lt = e, lt;
}
var ct, Hn;
function ri() {
  if (Hn) return ct;
  Hn = 1;
  var e = Wa(), t = Xa(), n = ei(), r = ur(), i = ti(), a = ni(), o = Math.min;
  function s(l, p, d) {
    for (var b = d ? n : t, g = l[0].length, m = l.length, u = m, v = Array(m), h = 1 / 0, S = []; u--; ) {
      var w = l[u];
      u && p && (w = r(w, i(p))), h = o(w.length, h), v[u] = !d && (p || g >= 120 && w.length >= 120) ? new e(u && w) : void 0;
    }
    w = l[0];
    var C = -1, k = v[0];
    e:
      for (; ++C < g && S.length < h; ) {
        var y = w[C], O = p ? p(y) : y;
        if (y = d || y !== 0 ? y : 0, !(k ? a(k, O) : b(S, O, d))) {
          for (u = m; --u; ) {
            var L = v[u];
            if (!(L ? a(L, O) : b(l[u], O, d)))
              continue e;
          }
          k && k.push(O), S.push(y);
        }
      }
    return S;
  }
  return ct = s, ct;
}
var ut, $n;
function fr() {
  if ($n) return ut;
  $n = 1;
  function e(t) {
    return t;
  }
  return ut = e, ut;
}
var pt, Gn;
function ai() {
  if (Gn) return pt;
  Gn = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return pt = e, pt;
}
var dt, Kn;
function ii() {
  if (Kn) return dt;
  Kn = 1;
  var e = ai(), t = Math.max;
  function n(r, i, a) {
    return i = t(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var o = arguments, s = -1, l = t(o.length - i, 0), p = Array(l); ++s < l; )
        p[s] = o[i + s];
      s = -1;
      for (var d = Array(i + 1); ++s < i; )
        d[s] = o[s];
      return d[i] = a(p), e(r, this, d);
    };
  }
  return dt = n, dt;
}
var gt, Un;
function oi() {
  if (Un) return gt;
  Un = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return gt = e, gt;
}
var ft, Bn;
function si() {
  if (Bn) return ft;
  Bn = 1;
  var e = Mt(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return ft = t, ft;
}
var mt, Qn;
function li() {
  if (Qn) return mt;
  Qn = 1;
  var e = oi(), t = si(), n = fr(), r = t ? function(i, a) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : n;
  return mt = r, mt;
}
var ht, Wn;
function ci() {
  if (Wn) return ht;
  Wn = 1;
  var e = 800, t = 16, n = Date.now;
  function r(i) {
    var a = 0, o = 0;
    return function() {
      var s = n(), l = t - (s - o);
      if (o = s, l > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return i.apply(void 0, arguments);
    };
  }
  return ht = r, ht;
}
var yt, Vn;
function ui() {
  if (Vn) return yt;
  Vn = 1;
  var e = li(), t = ci(), n = t(e);
  return yt = n, yt;
}
var vt, Yn;
function pi() {
  if (Yn) return vt;
  Yn = 1;
  var e = fr(), t = ii(), n = ui();
  function r(i, a) {
    return n(t(i, a, e), i + "");
  }
  return vt = r, vt;
}
var _t, Zn;
function di() {
  if (Zn) return _t;
  Zn = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return _t = t, _t;
}
var bt, Jn;
function gi() {
  if (Jn) return bt;
  Jn = 1;
  var e = gr(), t = di();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return bt = n, bt;
}
var xt, Xn;
function fi() {
  if (Xn) return xt;
  Xn = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return xt = e, xt;
}
var wt, er;
function mi() {
  if (er) return wt;
  er = 1;
  var e = gi(), t = fi();
  function n(r) {
    return t(r) && e(r);
  }
  return wt = n, wt;
}
var Ct, tr;
function hi() {
  if (tr) return Ct;
  tr = 1;
  var e = mi();
  function t(n) {
    return e(n) ? n : [];
  }
  return Ct = t, Ct;
}
var kt, nr;
function yi() {
  if (nr) return kt;
  nr = 1;
  var e = ur(), t = ri(), n = pi(), r = hi(), i = n(function(a) {
    var o = e(a, r);
    return o.length && o[0] === a[0] ? t(o) : [];
  });
  return kt = i, kt;
}
var vi = yi();
const _i = /* @__PURE__ */ $r(vi), bi = ["action"], mr = 24 * 60 * 60 * 1e3, xi = ({
  geoTargeting: e,
  userCountry: t
}) => {
  if (!e)
    return !0;
  const {
    type: n,
    userCountries: r
  } = e;
  if (r.length === 0)
    return !0;
  switch (n) {
    case "exclude":
      return !r.includes(t);
    case "include":
      return r.includes(t);
    default:
      return !0;
  }
}, wi = ({
  location: e,
  pageTargeting: t
}) => {
  if (!e || !t)
    return !0;
  const {
    excludedPathnameRegexList: n,
    excludedURLList: r,
    includedPathnameRegexList: i,
    includedURLList: a
  } = t, o = !n || n.every((d) => !new RegExp(d).test(e.pathname)), s = !r || r.every((d) => !e.href.includes(d)), l = !i || i.length === 0 || i.some((d) => new RegExp(d).test(e.pathname)), p = !a || a.length === 0 || a.some((d) => e.href.includes(d));
  return o && s && l && p;
}, Ci = ({
  userTypeIds: e,
  userTypeTargeting: t
}) => J(t) ? J(e) ? J(_i(e, t)) : !1 : !0, Q = ({
  config: e,
  userInfo: t
}) => {
  var n, r;
  const i = [e.localStorageKey, ...(n = e.disableWithLocalStorageKeys) !== null && n !== void 0 ? n : []].every((d) => localStorage.getItem(d) === null), a = xi({
    geoTargeting: e.geoTargeting,
    userCountry: t.userCountry
  }), o = wi({
    location: (r = Ar()) === null || r === void 0 ? void 0 : r.location,
    pageTargeting: e.pageTargeting
  }), s = Ci({
    userTypeIds: t.userTypeIds,
    userTypeTargeting: e.userTypeTargeting
  }), l = e.disableInMobile && t.userDevice === "mobile", p = e.anonymous && !t.isLoggedIn || e.login && t.isLoggedIn;
  return i && a && o && s && p && !l;
}, le = (e) => {
  const {
    campaignName: t,
    type: n
  } = e;
  return {
    description: `Log in or register to follow <span class="bold-text">${t}</span> and get notified on newly published stories.`,
    title: `Get notified on your favourite ${n}`
  };
}, ki = () => {
  const e = sessionStorage.getItem("popupShownTimestamp");
  return e ? Number.parseInt(e, 10) : null;
}, rr = () => {
  const e = Date.now() + mr;
  sessionStorage.setItem("popupShownTimestamp", e.toString());
}, Si = (e) => Date.now() - e > mr, Ii = (e, t) => {
  const {
    acquisition: {
      popupState: n
    },
    currentRouteWithoutQuerystring: r
  } = R(), {
    setWithTTL: i
  } = qi(), [a, o] = D(!1), [s, l] = D(), p = M(!1), d = M(!1), b = te(s), g = 5e3;
  lr(() => {
    o(!0);
  }, g);
  const m = q(() => {
    const u = Object.values(e).flatMap((C) => {
      var k;
      return (k = C.getNextFromAction) !== null && k !== void 0 ? k : [];
    });
    for (const C of u) {
      const y = C(() => {
        y != null && y.localStorageKey && !y.updateLocalStorageOnShow && i(y.localStorageKey), l(void 0);
      });
      if (y) {
        d.current = !0, l(y), y.updateLocalStorageOnShow && i(y.localStorageKey);
        return;
      }
    }
    if (!a || t.skipTriggerFromConfig) return;
    const v = ki();
    if (v !== null && !Si(v)) return;
    const h = Object.values(e).map((C) => C.getNextFromConfig);
    for (const C of h) {
      const y = C(() => {
        y != null && y.localStorageKey && !y.updateLocalStorageOnShow && i(y.localStorageKey), p.current = !1, l(void 0);
      });
      if (y) {
        var S;
        p.current = !0, setTimeout(() => {
          l(y), rr(), y.updateLocalStorageOnShow && i(y.localStorageKey);
        }, Math.max(((S = y.delay) !== null && S !== void 0 ? S : 0) - g, 0));
        return;
      }
    }
    const w = Object.values(e).flatMap((C) => {
      var k;
      return (k = C.getNextFromScrollPosition) !== null && k !== void 0 ? k : [];
    });
    for (const C of w) {
      const y = C(() => {
        y != null && y.localStorageKey && !y.updateLocalStorageOnShow && i(y.localStorageKey), l(void 0);
      });
      if (y) {
        l(y), rr(), y.updateLocalStorageOnShow && i(y.localStorageKey);
        return;
      }
    }
  }, [a, e, i, t.skipTriggerFromConfig]);
  return F(() => {
    p.current || d.current || !r || b.current !== void 0 || !Object.values(n).some((u) => J(u)) || m();
  }, [r, b, n, m]), {
    popup: b.current
  };
}, qi = () => {
  const e = q((t) => {
    Fr(t, Mr(/* @__PURE__ */ new Date(), 90).toISOString());
  }, []);
  return W(() => {
    for (const [r] of Object.entries(localStorage).filter(([i]) => ["ACQUISITION", "CAMPAIGN", "TOPIC_PACKAGE"].some((a) => i.startsWith(a)))) {
      var t, n;
      if (!jr(new Date((t = localStorage.getItem(r)) !== null && t !== void 0 ? t : ""))) {
        e(r);
        continue;
      }
      Dr(/* @__PURE__ */ new Date(), (n = localStorage.getItem(r)) !== null && n !== void 0 ? n : "") && localStorage.removeItem(r);
    }
  }), {
    setWithTTL: e
  };
}, Ti = (e) => /* @__PURE__ */ x.createElement("svg", { fill: "#fff", width: 16, height: 16, viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M16 .611L15.426 0 8 7.408.612 0 0 .611l7.388 7.408L0 15.39l.612.61L8 8.592 15.426 16l.574-.611-7.388-7.37z", fillRule: "evenodd" })), Ri = /* @__PURE__ */ f(Ti, {
  target: "e1yvcnez0"
})("position:absolute;inset-block-start:-10px;inset-inline-end:-10px;inline-size:24px;block-size:24px;padding:4px;border-radius:50%;background-color:#222222;cursor:pointer;", Gr, ";"), H = ({
  onClose: e
}) => /* @__PURE__ */ c.createElement(Ri, {
  onClick: e,
  "data-qa": "close-button"
});
H.displayName = "CloseButton";
const jt = /* @__PURE__ */ f("div", {
  target: "e1d54s182"
})({
  name: "nwi359",
  styles: "position:fixed;inset-block:0 0;inset-inline:0 0;z-index:-1;opacity:0.8;-webkit-tap-highlight-color:transparent"
}), zi = /* @__PURE__ */ f(jt, {
  target: "e1d54s181"
})({
  name: "qr3hfl",
  styles: "background-color:#27303e"
}), Li = /* @__PURE__ */ f(jt, {
  target: "e1d54s180"
})({
  name: "pz9wym",
  styles: "background-color:#ffffff"
}), Y = /* @__PURE__ */ f(jt, {
  target: "e17jtchq0"
})({
  name: "taq9ah",
  styles: "background:#000000;opacity:0.5"
}), Ei = /* @__PURE__ */ f(aa, {
  target: "evs3m4a0"
})("z-index:", ia.Modal, ";display:flex;justify-content:center;align-items:center;-webkit-tap-highlight-color:transparent;*,*::before,*::after{box-sizing:border-box;outline:none;}");
function qt() {
  return qt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qt.apply(null, arguments);
}
const $ = ({
  backdropColor: e,
  BackdropComponent: t,
  children: n,
  fadeTimeout: r,
  ...i
}) => /* @__PURE__ */ c.createElement(Ei, qt({}, i, {
  closeAfterTransition: !0,
  slots: {
    backdrop: t ?? (e === "light" ? Li : zi)
  },
  "data-qa": "modal"
}), /* @__PURE__ */ c.createElement(Kr, {
  in: i.open,
  timeout: r ?? 300
}, n));
$.displayName = "Modal";
const Oi = /* @__PURE__ */ f("div", {
  target: "e9bvxhk4"
})("position:relative;inline-size:280px;max-block-size:476px;margin:auto;background-color:#001246;outline:none;", _.breakpoints.up("mobile"), "{inline-size:calc(100vw - 40px);max-block-size:670px;}", _.breakpoints.up("tablet"), "{inline-size:600px;max-block-size:729px;}"), Pi = /* @__PURE__ */ f("div", {
  target: "e9bvxhk3"
})("display:flex;justify-content:center;align-items:center;inline-size:100%;block-size:100%;max-block-size:187px;overflow:hidden;", _.breakpoints.up("mobile"), "{block-size:224px;max-block-size:224px;}", _.breakpoints.up("tablet"), "{inline-size:600px;block-size:400px;max-inline-size:600px;max-block-size:400px;}img{display:block;inline-size:100%;block-size:100%;object-fit:cover;}"), Ni = /* @__PURE__ */ f("div", {
  target: "e9bvxhk2"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;inline-size:100%;block-size:289px;padding-block:16px;padding-inline:20px;", _.breakpoints.up("tablet"), "{block-size:250px;max-inline-size:600px;padding:40px;}"), Ai = /* @__PURE__ */ f("div", {
  target: "e9bvxhk1"
})("margin-block-end:12px;color:#ffca05;font-size:20px;font-family:", B, ";line-height:25px;text-align:center;"), Fi = /* @__PURE__ */ f("div", {
  target: "e9bvxhk0"
})("margin-block-end:12px;color:#ffffff;font-size:15px;font-family:", z, ";line-height:19px;text-align:center;span{font-weight:700;}"), hr = ({
  acquisition: e,
  modalContainerReference: t,
  onClose: n
}) => {
  const {
    description: r,
    image: i,
    title: a
  } = e.content, o = P(() => {
    var b, g;
    return (b = e.tid ? [{
      entityId: e.tid,
      name: e.name
    }] : (g = e.tids) === null || g === void 0 ? void 0 : g.map((m) => ({
      entityId: m,
      name: e.name
    }))) !== null && b !== void 0 ? b : [];
  }, [e.name, e.tid, e.tids]), {
    handleTrackGA4: s
  } = R(), [l, p] = D(!1), d = e.campaign;
  return W(() => {
    s({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "nl_signup",
        internal_campaign: d,
        step: "1"
      },
      subcategory: ""
    });
  }), /* @__PURE__ */ c.createElement($, {
    BackdropComponent: Y,
    container: t == null ? void 0 : t.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "acquisition-newsletter-popup"
  }, /* @__PURE__ */ c.createElement(Oi, null, /* @__PURE__ */ c.createElement(H, {
    onClose: () => {
      s({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          internal_campaign: d,
          message: "close button",
          step: "1"
        },
        subcategory: ""
      }), n == null || n();
    }
  }), /* @__PURE__ */ c.createElement(Pi, null, /* @__PURE__ */ c.createElement("img", {
    alt: a,
    src: i
  })), /* @__PURE__ */ c.createElement(Ni, null, !l && /* @__PURE__ */ c.createElement(c.Fragment, null, /* @__PURE__ */ c.createElement(Ai, {
    dangerouslySetInnerHTML: {
      __html: a
    }
  }), /* @__PURE__ */ c.createElement(Fi, {
    dangerouslySetInnerHTML: {
      __html: r
    }
  })), /* @__PURE__ */ c.createElement(Ur, {
    campaignName: d,
    multipleNewsletters: !0,
    newsletterItems: o,
    onSuccess: () => {
      p(!0);
    },
    signUpButtonDisplayComponent: e.button.text,
    variant: Br.AcquisitionNewsletterPopup
  }))));
};
hr.displayName = "AcquisitionNewsletterPopup";
const Mi = (e) => {
  const {
    acquisition: {
      popupState: t
    },
    userCountry: n,
    userTypeIds: r
  } = R(), i = ae(_.breakpoints.only("mobile"), !1), a = q((s) => {
    var l;
    const p = Object.values(t.acquisitions).find((b) => Q({
      config: b,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: n ?? "",
        userDevice: i ? "mobile" : "desktop",
        userTypeIds: r
      }
    }));
    if (!p) return;
    const d = {
      acquisition: p,
      modalContainerReference: e.modalContainerReference,
      onClose: s
    };
    return {
      delay: Number.parseInt((l = p.timeout) !== null && l !== void 0 ? l : "0", 10),
      element: /* @__PURE__ */ c.createElement(hr, d),
      localStorageKey: p.localStorageKey,
      updateLocalStorageOnShow: !0
    };
  }, [i, e.isLoggedIn, e.modalContainerReference, t.acquisitions, n, r]);
  return P(() => ({
    getNextFromConfig: a
  }), [a]);
}, Dt = (e) => Object.values(K).map((t) => t.toLowerCase()).includes(e.toLowerCase()), ss = (e) => {
  switch (e.toLowerCase()) {
    case "author":
      return K.Author;
    case "section":
      return K.Section;
    case "topic":
      return K.Topic;
  }
};
function ji(e) {
  var t;
  const r = (t = V.parse(e, {
    ignoreQueryPrefix: !0
  }).action) === null || t === void 0 ? void 0 : t.follow_campaign;
  if (r)
    return r;
}
function Di(e) {
  const t = {
    action: {
      follow_campaign: e
    }
  };
  return V.stringify(t, {
    arrayFormat: "comma"
  });
}
const Hi = async (e) => {
  try {
    if ("scheduler" in window && window.scheduler) {
      if (window.scheduler.yield)
        return window.scheduler.yield(e);
      if (window.scheduler.postTask)
        return window.scheduler.postTask(() => {
        }, e);
    }
    return (e == null ? void 0 : e.priority) === "user-blocking" ? Promise.resolve() : new Promise((t) => setTimeout(t));
  } catch {
    return new Promise((t) => setTimeout(t));
  }
}, $i = ({
  className: e,
  disabled: t,
  display: n = j.Text,
  isFollowing: r,
  isLoadingEnabled: i = !1,
  loadingDelay: a = 1500,
  onClick: o,
  outline: s = It.Filled,
  size: l = St.Normal,
  variant: p = ne.Light
}) => {
  const [d, b] = D(!1), g = () => {
    o(r ? U.UnFollow : U.Follow);
  };
  lr(() => {
    b(!1);
  }, d ? a : void 0);
  const m = () => {
    (async () => (await Hi({
      priority: "user-blocking"
    }), i && b(!0), g()))();
  }, u = () => {
    if (d)
      return /* @__PURE__ */ c.createElement(Wr, null);
    const v = p === ne.Homepage ? /* @__PURE__ */ c.createElement(Vr, null) : /* @__PURE__ */ c.createElement(Yr, null);
    switch (n) {
      case j.BlueIcon:
        return r ? v : /* @__PURE__ */ c.createElement(na, null);
      case j.BluePlusIcon:
        return r ? "FOLLOWING" : /* @__PURE__ */ c.createElement(Xr, null, /* @__PURE__ */ c.createElement(ea, null), /* @__PURE__ */ c.createElement(ta, null, "FOLLOW"));
      case j.BlueSquareIcon:
        return r ? v : /* @__PURE__ */ c.createElement(Jr, null);
      case j.CircleGrayIcon:
        return r ? v : /* @__PURE__ */ c.createElement(Zr, null);
      case j.Text:
        return r ? "FOLLOWING" : "+ FOLLOW";
    }
  };
  return /* @__PURE__ */ c.createElement(Qr, {
    "aria-label": "follow",
    className: e,
    disabled: t,
    isFollowing: r,
    isLoading: d,
    onClick: m,
    outline: s,
    size: l,
    variant: p,
    "data-qa": "follow-button"
  }, u());
}, Gi = /* @__PURE__ */ f("a", {
  target: "egvrj6w0"
})("display:block;padding-block:10px;padding-inline:20px;color:#001246;font-size:16px;font-family:", z, ";line-height:19px;text-align:center;text-decoration:none;border-radius:3px;background-color:#ffca05;cursor:pointer;");
function Tt() {
  return Tt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tt.apply(null, arguments);
}
const Ht = ({
  children: e,
  className: t,
  onClick: n,
  url: r,
  ...i
}) => {
  const {
    handleRoutePush: a
  } = R();
  return /* @__PURE__ */ c.createElement(Gi, Tt({
    className: t,
    onClick: (o) => {
      a(r), n == null || n(o);
    },
    rel: "noreferrer",
    target: "_blank"
  }, i, {
    "data-qa": "redirect-button"
  }), e);
};
Ht.displayName = "RedirectButton";
const X = /* @__PURE__ */ f("img", {
  target: "e13oolsl8"
})({
  name: "225k98",
  styles: "inline-size:100%;block-size:100%;object-fit:cover"
}), ee = /* @__PURE__ */ f("div", {
  target: "e13oolsl7"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;inline-size:100%;>*+*{margin-block-start:12px;", _.breakpoints.up("tablet"), "{margin-block-start:8px;}}"), Rt = /* @__PURE__ */ f("div", {
  target: "e13oolsl6"
})("margin-block-start:0;text-align:center;", _.breakpoints.up("tablet"), "{margin-inline:20px;}"), zt = /* @__PURE__ */ f("div", {
  target: "e13oolsl5"
})("font-family:", z, ";", _.breakpoints.up("tablet"), "{margin-inline:20px;}span{font-weight:700;}"), yr = /* @__PURE__ */ f("div", {
  target: "e13oolsl4"
})("max-inline-size:240px;margin-block-end:8px;padding-block:4px;padding-inline:8px;color:#001246;font-weight:700;font-size:14px;font-family:", oa, ";text-align:center;background-color:#ffca05;", _.breakpoints.up("mobile"), "{font-size:16px;}"), Lt = /* @__PURE__ */ f(Ht, {
  target: "e13oolsl3"
})({
  name: "mmdt3g",
  styles: "font-size:14px"
}), vr = /* @__PURE__ */ f($i, {
  target: "e13oolsl2"
})("inline-size:108px;padding-block:10px;padding-inline:20px;font-size:14px;line-height:normal;", _.breakpoints.up("tablet"), "{inline-size:94px;padding-block:8px;padding-inline:0;line-height:14px;}"), Ki = /* @__PURE__ */ f("div", {
  target: "e13oolsl1"
})("position:relative;display:grid;margin:auto;outline:none;", X, "{grid-area:image;}", ee, "{grid-area:content;}", (e) => {
  switch (e.$variant) {
    case "soft":
      return /* @__PURE__ */ re('grid:"content" min-content "image" min-content/100%;background:#f6f6f6;inline-size:calc(100% - 40px);', _.breakpoints.up("mobile"), "{max-inline-size:368px;max-block-size:670px;}", _.breakpoints.up("tablet"), "{max-inline-size:600px;max-block-size:729px;}", ee, "{padding-block-start:0;padding-block-end:12px;}", Rt, "{color:#001246;font-weight:700;font-size:22px;font-family:", z, ";line-height:33px;text-align:center;", _.breakpoints.up("mobile"), "{font-size:28px;}}", zt, "{inline-size:252px;color:#000000;font-size:14px;line-height:18px;text-align:center;", _.breakpoints.up("tablet"), "{inline-size:400px;}}", X, "{padding:4px;block-size:169px;", _.breakpoints.up("tablet"), "{block-size:338px;}}", "");
    default:
      return /* @__PURE__ */ re('grid:"image" min-content "content" min-content/100%;background:#001246;max-inline-size:calc(100% - 40px);', _.breakpoints.up("mobile"), "{max-inline-size:335px;max-block-size:670px;}", _.breakpoints.up("tablet"), "{max-inline-size:600px;max-block-size:729px;}", ee, "{padding:16px 20px;", _.breakpoints.up("tablet"), "{padding:0;min-block-size:203px;}}", Rt, "{color:#ffca05;font-weight:400;font-size:16px;font-family:", B, ";line-height:normal;", _.breakpoints.up("tablet"), "{font-size:20px;}}", zt, "{color:#ffffff;font-weight:400;font-size:12px;line-height:normal;text-align:center;", _.breakpoints.up("tablet"), "{font-size:16px;}}", yr, "{display:none;}", X, "{block-size:187px;", _.breakpoints.down("mobile"), "{block-size:187px;}", _.breakpoints.up("mobile"), "{block-size:224px;}", _.breakpoints.up("tablet"), "{block-size:400px;}}", Lt, "{margin-block-start:24px;}", vr, "{margin-block-start:12px;", _.breakpoints.up("tablet"), "{margin-block-start:24px;}}", "");
  }
}, " ", _.breakpoints.up("tablet"), "{inline-size:600px;max-block-size:729px;}");
function Et() {
  return Et = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Et.apply(null, arguments);
}
const Ui = (e) => {
  var t;
  const {
    config: n,
    handleCheckIsFollowed: r,
    handleFollow: i,
    handleOpenLoginDialog: a,
    handleTrackGA4: o,
    user: s
  } = R(), l = (t = e.theme) !== null && t !== void 0 ? t : "follow", p = _r(l);
  return {
    render: (b) => {
      var g, m, u;
      const v = e.name, h = e.campaign;
      switch (l) {
        case "follow":
          if (!Dt(e.type)) return;
          const {
            name: S,
            tid: w,
            tids: C = [],
            type: k
          } = e, y = w ? [w] : C, O = y.every((E) => r({
            entityId: E,
            followType: k
          }));
          return /* @__PURE__ */ c.createElement(vr, Et({}, b.followButtonProps, {
            disabled: O,
            isFollowing: O,
            onClick: (E) => {
              if (E !== U.UnFollow) {
                if (o({
                  action: "click",
                  category: "follow",
                  customized_parameters: {
                    action_type: "follow",
                    follow_type: "topic",
                    internal_campaign: h,
                    topic_id: w ?? C.join(", "),
                    trigger_point: "ppto"
                  },
                  subcategory: ""
                }), o({
                  action: "click",
                  category: "promopopup",
                  customized_parameters: {
                    cta_type: p,
                    internal_campaign: h,
                    message: "follow",
                    step: "1"
                  },
                  subcategory: ""
                }), !s) {
                  const N = new URL(globalThis.location.href);
                  N.search = Di({
                    campaign: S
                  });
                  const {
                    description: ce,
                    title: ue
                  } = le({
                    campaignName: v,
                    type: k
                  });
                  a({
                    description: ce,
                    destination: N.toString(),
                    ga4CustomParameter: {
                      internal_campaign: h,
                      trigger_point: "ppto"
                    },
                    title: ue
                  });
                  return;
                }
                i({
                  action: E,
                  callback: () => {
                    o({
                      action: "sys",
                      category: "follow",
                      customized_parameters: {
                        action_type: "follow",
                        follow_type: "topic",
                        internal_campaign: h,
                        topic_id: w ?? C.join(", "),
                        trigger_point: "ppto"
                      },
                      subcategory: "result"
                    }), b.handlePopupClose && b.handlePopupClose();
                  },
                  entityIds: y,
                  followType: k
                });
              }
            }
          }));
        case "link":
          return /* @__PURE__ */ c.createElement(Lt, {
            onClick: () => {
              var E, N;
              o({
                action: "click",
                category: "promopopup",
                customized_parameters: {
                  cta_type: p,
                  destination_url: (E = e.content.redirectURL) !== null && E !== void 0 ? E : "",
                  internal_campaign: h,
                  message: (N = e.content.redirectTitle) !== null && N !== void 0 ? N : "",
                  step: "1"
                },
                subcategory: ""
              });
            },
            url: (g = e.content.redirectURL) !== null && g !== void 0 ? g : ""
          }, e.content.redirectTitle);
        case "subscribe":
          const L = new URL(n.subscribe.host);
          return L.searchParams.set("module", `semi-FPTO_${h}`), L.searchParams.set("pgtype", "article"), L.searchParams.set("promocode", (m = e.content.promoCode) !== null && m !== void 0 ? m : ""), L.searchParams.set("plan", (u = e.content.termCode) !== null && u !== void 0 ? u : ""), /* @__PURE__ */ c.createElement(Lt, {
            onClick: () => {
              o({
                action: "click",
                category: "promopopup",
                customized_parameters: {
                  cta_type: p,
                  internal_campaign: h,
                  message: "Subscribe",
                  step: "1"
                },
                subcategory: ""
              });
            },
            url: L.toString()
          }, "Subscribe");
        default:
          return null;
      }
    }
  };
}, _r = (e) => {
  switch (e) {
    case "follow":
      return "follow";
    case "link":
      return "url_redirect";
    case "subscribe":
      return "subscribe";
    default:
      return "follow";
  }
}, Ot = ({
  campaign: e,
  confirmedAction: t,
  modalContainerReference: n,
  onClose: r
}) => {
  const {
    handleFollow: i,
    handleTrackGA4: a
  } = R(), {
    content: o,
    layout: s = "default",
    tagline: l,
    theme: p
  } = e, {
    description: d,
    image: b,
    title: g
  } = o, m = Ui(e), u = M(i), v = M(a), h = e.campaign, S = _r(p);
  W(() => {
    t || a({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: S,
        internal_campaign: h,
        step: "1"
      },
      subcategory: ""
    });
  });
  const w = q(() => {
    a({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: S,
        internal_campaign: h,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    }), r();
  }, [h, S, r, a]);
  return F(() => {
    const {
      tid: C,
      tids: k = [],
      type: y
    } = e;
    t && u.current && v.current && Dt(y) && (u.current({
      action: U.Follow,
      callback: () => {
        v.current({
          action: "sys",
          category: "follow",
          customized_parameters: {
            action_type: "follow",
            follow_type: "topic",
            internal_campaign: h,
            topic_id: C ?? k.join(", "),
            trigger_point: "ppto"
          },
          subcategory: "result"
        });
      },
      entityIds: C ? [C] : k,
      followType: y
    }), r());
  }, [e, h, t, u, v, r]), t ? null : /* @__PURE__ */ c.createElement($, {
    BackdropComponent: Y,
    container: n == null ? void 0 : n.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "campaign-popup"
  }, /* @__PURE__ */ c.createElement(Ki, {
    $variant: s
  }, /* @__PURE__ */ c.createElement(H, {
    onClose: w
  }), /* @__PURE__ */ c.createElement(X, {
    alt: g,
    src: b
  }), /* @__PURE__ */ c.createElement(ee, null, /* @__PURE__ */ c.createElement(yr, {
    dangerouslySetInnerHTML: {
      __html: l
    }
  }), /* @__PURE__ */ c.createElement(Rt, {
    dangerouslySetInnerHTML: {
      __html: g
    }
  }), /* @__PURE__ */ c.createElement(zt, {
    dangerouslySetInnerHTML: {
      __html: d
    }
  }), m.render({
    followButtonProps: {
      outline: s === "soft" ? It.Filled : It.Outlined,
      size: s === "soft" ? St.Large : St.Normal,
      variant: s === "soft" ? ne.Light : ne.Dark
    },
    handlePopupClose: r
  }))));
};
Ot.displayName = "CampaignPopup";
const Bi = (e) => {
  const {
    acquisition: {
      popupState: t
    },
    currentRoute: n,
    handleOpenLoginDialog: r,
    handleRemoveRouteQuery: i,
    userCountry: a,
    userTypeIds: o
  } = R(), s = q(() => i(bi), [i]), l = q((g) => {
    const m = ji(new URL(n, globalThis.location.origin).search);
    if (!m) return;
    const u = Object.values(t.campaigns).find((h) => h.name === m.campaign);
    if (!u) return;
    if (!e.isLoggedIn) {
      const {
        description: h,
        title: S
      } = le({
        campaignName: u.campaign,
        type: u.type
      });
      r({
        description: h,
        destination: globalThis.location.href,
        ga4CustomParameter: {
          internal_campaign: u.campaign,
          trigger_point: "ppto"
        },
        title: S
      }), s();
      return;
    }
    const v = {
      campaign: u,
      confirmedAction: !0,
      modalContainerReference: e.modalContainerReference,
      onClose: g
    };
    return s(), {
      element: /* @__PURE__ */ c.createElement(Ot, v),
      localStorageKey: u.localStorageKey
    };
  }, [n, t.campaigns, e.isLoggedIn, e.modalContainerReference, s, r]), p = ae(_.breakpoints.only("mobile"), !1), d = q((g) => {
    var m;
    const u = Object.values(t.campaigns).find((h) => Dt(h.type) && Q({
      config: h,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: a ?? "",
        userDevice: p ? "mobile" : "desktop",
        userTypeIds: o
      }
    }));
    if (!u) return;
    const v = {
      campaign: u,
      modalContainerReference: e.modalContainerReference,
      onClose: g
    };
    return {
      delay: Number.parseInt((m = u.timeout) !== null && m !== void 0 ? m : "0", 10),
      element: /* @__PURE__ */ c.createElement(Ot, v),
      localStorageKey: u.localStorageKey
    };
  }, [p, e.isLoggedIn, e.modalContainerReference, t.campaigns, a, o]);
  return P(() => ({
    getNextFromAction: l,
    getNextFromConfig: d
  }), [d, l]);
}, Qi = (e) => /* @__PURE__ */ x.createElement("svg", { width: 56, height: 57, viewBox: "0 0 56 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("g", { clipPath: "url(#clip0_2249_45204)" }, /* @__PURE__ */ x.createElement("path", { d: "M0 28C0 12.536 12.536 0 28 0C43.4639 0 56 12.536 56 28C56 43.4639 43.4639 56 28 56C12.536 56 0 43.4639 0 28Z", fill: "#FFCA05" }), /* @__PURE__ */ x.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6839 30.8533L24.4082 41.5782L42.2491 23.7374C43.1603 22.8262 43.1603 21.3488 42.2491 20.4376C41.3377 19.5263 39.8605 19.5263 38.9491 20.4376L24.4082 34.9786L16.9838 27.5537C16.0726 26.6423 14.5952 26.6423 13.6839 27.5535C12.7727 28.4646 12.7727 29.9421 13.6839 30.8533Z", fill: "#001246" })), /* @__PURE__ */ x.createElement("defs", null, /* @__PURE__ */ x.createElement("clipPath", { id: "clip0_2249_45204" }, /* @__PURE__ */ x.createElement("rect", { width: 56, height: 56, fill: "white", transform: "translate(0 0.346191)" })))), Wi = /* @__PURE__ */ f(Ht, {
  target: "e1o2l8zf6"
})("block-size:43.65px;min-inline-size:252px;margin-block-start:40px;color:#ffffff;font-weight:400;font-size:16px;font-family:", z, ";line-height:19px;border:1px solid #4585ff;border-radius:3px;background:#001246;cursor:pointer;", _.breakpoints.up("tablet"), "{inline-size:270px;}"), Vi = /* @__PURE__ */ f("div", {
  target: "e1o2l8zf5"
})("position:relative;display:flex;justify-content:center;align-items:center;inline-size:calc(100vw - 20px);margin:auto;background-color:#ffffff;outline:none;", _.breakpoints.up("mobile"), "{inline-size:335px;}", _.breakpoints.up("tablet"), "{inline-size:440px;}");
_.breakpoints.up("tablet");
const Yi = /* @__PURE__ */ f("div", {
  target: "e1o2l8zf3"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;max-inline-size:300px;padding-block:40px;padding-inline:20px;text-align:center;", _.breakpoints.up("tablet"), "{max-inline-size:440px;padding:48px;}"), Zi = /* @__PURE__ */ f("div", {
  target: "e1o2l8zf2"
})("margin-block-start:16px;color:#001246;font-weight:900;font-size:20px;font-family:", B, ";line-height:24px;", _.breakpoints.up("tablet"), "{inline-size:320px;font-size:24px;line-height:29px;}"), Ji = /* @__PURE__ */ f("div", {
  target: "e1o2l8zf1"
})("max-inline-size:250px;margin-block-start:17px;color:#000000;font-weight:400;font-size:14px;font-family:", z, ";line-height:20px;text-align:center;", _.breakpoints.up("tablet"), "{max-inline-size:100%;font-size:16px;line-height:22px;}ul{display:flex;flex-flow:column;justify-content:center;align-items:center;list-style:disc inside;}"), Xi = /* @__PURE__ */ f("a", {
  target: "e1o2l8zf0"
})({
  name: "10up1tw",
  styles: "color:#4585ff;text-decoration:underline;cursor:pointer"
}), br = ({
  config: e,
  modalContainerReference: t,
  onClose: n
}) => {
  const {
    currentRoute: r
  } = R(), i = r.toLowerCase() === "mynews", a = () => i ? e.button.inMyNewsText : e.button.otherPageText;
  return /* @__PURE__ */ c.createElement($, {
    BackdropComponent: Y,
    container: t == null ? void 0 : t.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "my-news-completion-popup"
  }, /* @__PURE__ */ c.createElement(Vi, null, /* @__PURE__ */ c.createElement(H, {
    onClose: () => {
      n();
    }
  }), /* @__PURE__ */ c.createElement(Yi, null, /* @__PURE__ */ c.createElement(Qi, null), /* @__PURE__ */ c.createElement(Zi, {
    dangerouslySetInnerHTML: {
      __html: e.headline
    }
  }), /* @__PURE__ */ c.createElement(Ji, null, sa(e.description, {
    replace: (o) => o instanceof la && o.name === "download-link" ? /* @__PURE__ */ c.createElement(Xi, {
      onClick: () => {
        window.open("https://scmp.onelink.me/3586748601/aalocqf2", "_blank");
      }
    }, "download") : o
  })), /* @__PURE__ */ c.createElement(Wi, {
    dangerouslySetInnerHTML: {
      __html: a()
    },
    onClick: () => {
      n();
    },
    url: "/mynews"
  }))));
};
br.displayName = "MyNewsCompletionPopup";
const eo = (e) => {
  var t, n;
  const {
    acquisition: {
      popupState: r
    },
    currentPageType: i,
    handleTrackGA4: a,
    hasEnoughFollowedItems: o,
    initialHasEnoughFollowedItems: s
  } = R(), l = P(() => {
    var g;
    return (
      // 1. Is not posties pages
      !Pr.includes(i) && // 2. Drupal Config is on
      ((g = r.myNews.config) === null || g === void 0 || (g = g.completion_popup) === null || g === void 0 ? void 0 : g.isEnabled) && // 3. Is Logged in
      e.isLoggedIn && // 4. Followed items length is larger than threshold
      o && // 5. Snapshot list length is not larger than threshold (So if the user already followed more than threshold in the beginning, the popup will not show)
      !s
    );
  }, [i, o, s, e.isLoggedIn, (t = r.myNews.config) === null || t === void 0 || (t = t.completion_popup) === null || t === void 0 ? void 0 : t.isEnabled]), p = q((g) => {
    var m, u, v;
    if (!((m = r.myNews) !== null && m !== void 0 && m.completion) || !l) return;
    const h = (u = r.myNews) === null || u === void 0 || (u = u.completion) === null || u === void 0 ? void 0 : u.localStorageKey;
    if (localStorage.getItem(h) !== null) return;
    const w = {
      config: (v = r.myNews) === null || v === void 0 ? void 0 : v.completion,
      modalContainerReference: e.modalContainerReference,
      onClose: g
    };
    return {
      element: /* @__PURE__ */ c.createElement(br, w),
      localStorageKey: h
    };
  }, [l, e.modalContainerReference, (n = r.myNews) === null || n === void 0 ? void 0 : n.completion]), d = M(!1);
  return F(() => {
    d.current || l && (a({
      action: "sys",
      category: "mynews",
      customized_parameters: {
        trigger_point: "mynews_setup"
      },
      subcategory: "completion"
    }), d.current = !0);
  }, [l, a]), P(() => ({
    getNextFromConfig: p
  }), [p]);
};
function to(e) {
  var t;
  const r = (t = V.parse(e, {
    ignoreQueryPrefix: !0
  }).action) === null || t === void 0 ? void 0 : t.follow_topic_package;
  if (!(!r || r.checkedIndex.length === 0))
    return r;
}
function no(e) {
  const t = {
    action: {
      follow_topic_package: e
    }
  };
  return V.stringify(t, {
    arrayFormat: "comma"
  });
}
const ro = (e) => /* @__PURE__ */ x.createElement("svg", { width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", fill: "231F20", xmlSpace: "preserve", ...e }, /* @__PURE__ */ x.createElement("path", { d: "M9.835 12.715H5.537v1.436h4.298v4.303h1.441v-4.303h4.298v-1.436h-4.298V8.412H9.835v4.303z" }), /* @__PURE__ */ x.createElement("path", { d: "M.5 5.546V21.32c0 1.195.97 2.171 2.17 2.171h15.776c1.195 0 2.171-.97 2.171-2.17v-2.093h.712a2.174 2.174 0 0 0 2.172-2.172V2.68A2.176 2.176 0 0 0 21.329.508H6.951a2.168 2.168 0 0 0-2.165 2.17v.697H2.67a2.17 2.17 0 0 0-2.172 2.17zm17.94-2.171H6.24v-.696c0-.393.32-.713.712-.713H21.33c.393 0 .713.32.713.713v14.378c0 .393-.32.713-.713.713h-.712V5.546a2.178 2.178 0 0 0-2.177-2.171zM1.952 21.32V5.546c0-.393.32-.713.713-.713H18.44c.393 0 .713.32.713.713V21.32c0 .393-.32.713-.713.713H2.665a.713.713 0 0 1-.713-.713z" })), xr = (e) => /* @__PURE__ */ x.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("circle", { cx: 12, cy: 12.5, r: 10, fill: "white" }), /* @__PURE__ */ x.createElement("path", { d: "M20.4844 4.01562C18.1406 1.67188 15.3125 0.5 12 0.5C8.6875 0.5 5.85938 1.67188 3.51562 4.01562C1.17188 6.35938 0 9.1875 0 12.5C0 15.8125 1.17188 18.6406 3.51562 20.9844C5.85938 23.3281 8.6875 24.5 12 24.5C15.3125 24.5 18.1406 23.3281 20.4844 20.9844C22.8281 18.6406 24 15.8125 24 12.5C24 9.1875 22.8281 6.35938 20.4844 4.01562ZM18.0938 9.5L10.5 17.0938L5.90625 12.5C5.4375 12.0312 5.4375 11.5625 5.90625 11.0938C6.34375 10.6562 6.8125 10.6562 7.3125 11.0938L10.5 14.2812L16.6875 8.09375C17.1875 7.65625 17.6562 7.65625 18.0938 8.09375C18.5625 8.5625 18.5625 9.03125 18.0938 9.5Z", fill: "#001246" })), ao = /* @__PURE__ */ f("div", {
  target: "e19uvh0513"
})({
  name: "g5nysp",
  styles: "position:relative;inline-size:calc(100vw - 20px);max-inline-size:600px;margin:auto"
}), wr = /* @__PURE__ */ f("div", {
  target: "e19uvh0512"
})("display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;inline-size:calc(100vw - 20px);max-inline-size:600px;padding-block:24px;padding-inline:20px;background-color:#f6f6f6;>*+*{margin-block-start:12px;}", _.breakpoints.up("tablet"), "{margin-inline:unset;padding-inline:100px;}"), io = /* @__PURE__ */ f(wr, {
  target: "e19uvh0511"
})({
  name: "2qm2l6",
  styles: "padding-block:24px"
}), Cr = /* @__PURE__ */ f("div", {
  target: "e19uvh0510"
})("color:#001149;font-weight:300;font-size:24px;font-family:", z, ";line-height:28px;text-align:center;"), oo = /* @__PURE__ */ f(Cr, {
  target: "e19uvh059"
})({
  name: "mmvz9h",
  styles: "font-weight:400"
}), so = /* @__PURE__ */ f("div", {
  target: "e19uvh058"
})({
  name: "4vohe2",
  styles: ">*+*{margin-block-start:16px;}"
}), lo = /* @__PURE__ */ f(ro, {
  target: "e19uvh057"
})({
  name: "eykqtd",
  styles: "flex:none"
}), Pt = /* @__PURE__ */ f(xr, {
  target: "e19uvh056"
})({
  name: "eykqtd",
  styles: "flex:none"
}), co = /* @__PURE__ */ f(xr, {
  target: "e19uvh055"
})({
  name: "zufsyu",
  styles: "flex:none;inline-size:56px;block-size:56px;circle{fill:#001246;}path{fill:#ffca05;}"
}), uo = /* @__PURE__ */ f("span", {
  target: "e19uvh054"
})("flex:1;font-weight:700;font-size:16px;font-family:", z, ";font-style:normal;line-height:19px;"), po = /* @__PURE__ */ f("div", {
  target: "e19uvh053"
})("display:flex;flex-flow:row nowrap;gap:10px;justify-content:space-between;align-items:center;block-size:51px;padding-block:8px;padding-inline:20px 16px;border-radius:30px;cursor:pointer;", _.breakpoints.up("mobile"), "{inline-size:312px;}", (e) => e.$isChecked ? /* @__PURE__ */ re("background:#ffca05;", Pt, "{circle{fill:#ffffff;}path{fill:#001246;}}", "") : /* @__PURE__ */ re("border:1px solid #bbbbbb;background:#ffffff;", Pt, "{opacity:0.2;circle{fill:#a1a1a1;}path{fill:#a1a1a1;}}", ""), ";"), ar = /* @__PURE__ */ f("div", {
  target: "e19uvh052"
})("color:#000000;font-weight:400;font-size:14px;font-family:", z, ";line-height:18px;text-align:center;");
var go = {
  name: "17b7sab",
  styles: "color:#ffffff;background:#001246;cursor:pointer"
}, fo = {
  name: "xal2p",
  styles: "color:#000000;background:#e5e5e5;cursor:not-allowed"
};
const ir = /* @__PURE__ */ f("button", {
  target: "e19uvh051"
})("align-items:center;padding-block:15px;padding-inline:50px;font-size:16px;font-family:", z, ";text-align:center;text-transform:uppercase;border:none;border-radius:4px;", (e) => e.$isDisabled ? fo : go, ";"), mo = /* @__PURE__ */ f("a", {
  target: "e19uvh050"
})("color:#001246;font-size:14px;font-family:", z, ";font-style:normal;line-height:18px;text-align:center;text-decoration-line:underline;cursor:pointer;"), or = ({
  confirmedConfig: e,
  modalContainerReference: t,
  onClose: n,
  topicPackageFollow: r
}) => {
  const i = r.stepForm.step1, a = r.stepForm.step2, {
    displayName: o,
    key: s,
    shouldShowThankYouPopup: l,
    trackingActionName: p
  } = r, {
    config: d,
    handleFollow: b,
    handleOpenLoginDialog: g,
    handleRoutePush: m,
    handleTrackGA4: u,
    user: v
  } = R(), h = p;
  W(() => {
    if (e) {
      l && u({
        action: "imp",
        category: "promopopup",
        customized_parameters: {
          cta_type: "follow",
          internal_campaign: h,
          step: "2"
        },
        subcategory: ""
      }), L(), l || n();
      return;
    }
    u({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: h,
        step: "1"
      },
      subcategory: ""
    });
  });
  const S = () => {
    u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: h,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    }), n();
  }, [w, C] = da(i.topicPackageDefaultOptionList.map((T, I) => e != null && e.checkedItemIndex ? {
    ...T,
    checked: e.checkedItemIndex.includes(I)
  } : {
    ...T,
    checked: T.defaultChecked
  }));
  F(() => {
    C.reset();
  }, [C, i.topicPackageDefaultOptionList, e == null ? void 0 : e.checkedItemIndex]);
  const k = (T) => {
    const I = w[T];
    C.updateAt(T, {
      ...I,
      checked: !I.checked
    }), u({
      action: "click",
      category: "follow",
      customized_parameters: {
        action_type: I.checked ? "unfollow" : "follow",
        follow_type: "topic_package",
        internal_campaign: h,
        package_name: I.optionLabel,
        topic_id: I.topicIdList.join(", "),
        trigger_point: "ppto"
      },
      subcategory: ""
    });
  }, [y, O] = D((e == null ? void 0 : e.checkedItemIndex) && e.checkedItemIndex.length > 0), L = q(() => {
    if (!v) {
      const I = w.reduce(($t, Tr, Rr) => (Tr.checked && $t.push(Rr), $t), []), A = new URL(globalThis.location.origin + globalThis.location.pathname);
      A.search = no({
        checkedIndex: I,
        configKey: s
      });
      const {
        description: Ir,
        title: qr
      } = le({
        campaignName: o,
        type: "topics"
      });
      g({
        description: Ir,
        destination: A.toString(),
        ga4CustomParameter: {
          internal_campaign: h,
          trigger_point: "ppto"
        },
        title: qr
      });
      return;
    }
    const T = w.filter((I) => I.checked);
    b({
      action: U.Follow,
      callback: () => {
        const I = T.map((A) => A.optionLabel).join(", ");
        u({
          action: "sys",
          category: "follow",
          customized_parameters: {
            action_type: "follow",
            follow_type: "topic_package",
            internal_campaign: h,
            package_name: I,
            topic_id: T.flatMap((A) => A.topicIdList).join(", "),
            trigger_point: "ppto"
          },
          subcategory: "result"
        });
      },
      entityIds: T.flatMap((I) => I.topicIdList),
      followType: K.Topic
    }), O(!0);
  }, [h, o, b, g, u, w, s, v]), E = w.every((T) => !T.checked), N = () => {
    E || (u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: h,
        message: i.buttonText,
        step: "1"
      },
      subcategory: ""
    }), L(), l || n());
  }, ce = () => {
    u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        internal_campaign: h,
        message: a.buttonText,
        step: "2"
      },
      subcategory: ""
    }), n();
  }, ue = (T) => {
    T == null || T.preventDefault();
    const I = "/manage/following?module=topic_package&pgtype=article";
    u({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "follow",
        destination_url: I,
        internal_campaign: h,
        message: a.bottomLinkText,
        step: "2"
      },
      subcategory: ""
    });
    const A = `${d.accounts.host}${I}`;
    m(A, {
      isExternal: !0
    });
  };
  return !l && y ? null : /* @__PURE__ */ c.createElement($, {
    BackdropComponent: Y,
    container: t == null ? void 0 : t.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "topic-package-follow-popup"
  }, /* @__PURE__ */ c.createElement(ao, null, /* @__PURE__ */ c.createElement(H, {
    onClose: S
  }), y ? /* @__PURE__ */ c.createElement(io, null, /* @__PURE__ */ c.createElement(co, null), /* @__PURE__ */ c.createElement(oo, {
    dangerouslySetInnerHTML: {
      __html: a.title
    }
  }), /* @__PURE__ */ c.createElement(ar, {
    dangerouslySetInnerHTML: {
      __html: a.description
    }
  }), /* @__PURE__ */ c.createElement(ir, {
    dangerouslySetInnerHTML: {
      __html: a.buttonText
    },
    onClick: ce
  }), /* @__PURE__ */ c.createElement(mo, {
    dangerouslySetInnerHTML: {
      __html: a.bottomLinkText
    },
    onClick: ue
  })) : /* @__PURE__ */ c.createElement(wr, null, /* @__PURE__ */ c.createElement(Cr, {
    dangerouslySetInnerHTML: {
      __html: i.title
    }
  }), /* @__PURE__ */ c.createElement(so, null, i.topicPackageDefaultOptionList.map((T, I) => /* @__PURE__ */ c.createElement(po, {
    $isChecked: w[I].checked,
    key: I,
    onClick: () => k(I)
  }, /* @__PURE__ */ c.createElement(lo, null), /* @__PURE__ */ c.createElement(uo, {
    dangerouslySetInnerHTML: {
      __html: T.optionLabel
    }
  }), /* @__PURE__ */ c.createElement(Pt, null)))), /* @__PURE__ */ c.createElement(ar, {
    dangerouslySetInnerHTML: {
      __html: i.description
    }
  }), /* @__PURE__ */ c.createElement(ir, {
    $isDisabled: E,
    dangerouslySetInnerHTML: {
      __html: i.buttonText
    },
    onClick: N
  }))));
}, ho = ["action"];
function yo(e) {
  const {
    acquisition: {
      popupState: t
    },
    currentRoute: n,
    handleOpenLoginDialog: r,
    handleRemoveRouteQuery: i,
    userCountry: a,
    userTypeIds: o
  } = R(), s = ae(_.breakpoints.only("mobile"), !1), l = q(() => i(ho), [i]), p = q((g) => {
    const m = to(new URL(n, globalThis.location.origin).search);
    if (!m) return;
    const u = t.topicPackageFollows[m.configKey];
    if (!u) return;
    if (!e.isLoggedIn) {
      const {
        description: h,
        title: S
      } = le({
        campaignName: u.displayName,
        type: "topics"
      });
      r({
        description: h,
        destination: globalThis.location.href,
        ga4CustomParameter: {
          internal_campaign: u == null ? void 0 : u.trackingActionName,
          trigger_point: "ppto"
        },
        title: S
      }), l();
      return;
    }
    const v = {
      confirmedConfig: {
        checkedItemIndex: m.checkedIndex
      },
      modalContainerReference: e.modalContainerReference,
      onClose: g,
      topicPackageFollow: {
        ...u,
        key: m.configKey
      }
    };
    return l(), {
      element: /* @__PURE__ */ c.createElement(or, v),
      localStorageKey: u.localStorageKey
    };
  }, [n, r, l, e.isLoggedIn, e.modalContainerReference, t.topicPackageFollows]), d = q((g) => {
    const m = Object.entries(t.topicPackageFollows).find(([S, w]) => Q({
      config: w,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: a ?? "",
        userDevice: s ? "mobile" : "desktop",
        userTypeIds: o
      }
    }));
    if (!m) return;
    const [u, v] = m, h = {
      modalContainerReference: e.modalContainerReference,
      onClose: g,
      topicPackageFollow: {
        ...v,
        key: u
      },
      trackingName: v.trackingActionName
    };
    return {
      delay: Number.parseInt(v.timeout, 10),
      element: /* @__PURE__ */ c.createElement(or, h),
      localStorageKey: v.localStorageKey
    };
  }, [s, e.isLoggedIn, e.modalContainerReference, t.topicPackageFollows, a, o]);
  return P(() => ({
    getNextFromAction: p,
    getNextFromConfig: d
  }), [d, p]);
}
const vo = (e) => {
  var t, n;
  const r = V.parse(e, {
    ignoreQueryPrefix: !0
  });
  return ra(Object.keys((t = (n = r.action) === null || n === void 0 ? void 0 : n.ppto_why_reg) !== null && t !== void 0 ? t : {}));
}, _o = (e) => {
  const t = new URL(globalThis.location.origin + globalThis.location.pathname);
  return t.search = `action[ppto_why_reg][${e}]`, t.toString();
}, bo = (e) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ x.createElement("path", { d: "m27.436 11.764c0.5983 0.6207 0.8979 1.3731 0.8979 2.2557v15.147l-8.2615-5.2997-8.4052 5.2997v-15.147c0-0.8826 0.2988-1.635 0.8979-2.2557 0.599-0.62 1.3169-0.9311 2.1556-0.9311h10.56c0.8374 0 1.556 0.3111 2.155 0.9311z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), xo = (e) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ x.createElement("path", { d: "m27.444 11.764c0.5924 0.6207 0.8889 1.3731 0.8889 2.2557v8.8445c0 0.8839-0.2965 1.6356-0.8889 2.2556-0.5929 0.6214-1.3077 0.9311-2.1448 0.9311h-8.7172l-4.9158 3.1154v-15.147c0-0.8826 0.2958-1.635 0.8888-2.2557 0.593-0.62 1.3077-0.9311 2.1442-0.9311h10.6c0.8371 0 1.5519 0.3111 2.1448 0.9311z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), wo = (e) => /* @__PURE__ */ x.createElement("svg", { width: 21, height: 16, viewBox: "0 0 21 16", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ x.createElement("path", { fill: "#FEFEFE", d: "M0 15.984h20.593V0H0z" }), /* @__PURE__ */ x.createElement("path", { fill: "#FFCA05", d: "M1.777 14.194h7.627V1.788H1.777z" }), /* @__PURE__ */ x.createElement("path", { fill: "#001246", d: "M11.189 14.194h7.627V1.788H11.19z" }))), Co = (e) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ x.createElement("path", { d: "m27.071 27.07c1.9529-1.9529 2.9293-4.3093 2.9293-7.07 0-2.76-0.9764-5.1171-2.9293-7.0707-1.9536-1.9529-4.3107-2.9293-7.0707-2.9293-2.7607 0-5.1171 0.9764-7.07 2.9293-1.9536 1.9536-2.93 4.3107-2.93 7.0707 0 2.7607 0.9764 5.1171 2.93 7.07 1.9529 1.9536 4.3093 2.93 7.07 2.93 2.76 0 5.1171-0.9764 7.0707-2.93zm-3.0317-7.4934h-3.555v-3.555h-1.0157v3.555h-3.5543v1.0157h3.5543v3.5543h1.0157v-3.5543h3.555v-1.0157z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), ko = (e) => /* @__PURE__ */ x.createElement("svg", { viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ x.createElement("rect", { width: 40, height: 40, rx: 20, fill: "#C79A00", fillOpacity: 0.2 }), /* @__PURE__ */ x.createElement("path", { d: "m30 17.847c0 0.1691-0.1122 0.3667-0.3358 0.5914l-4.3279 4.2636 1.0081 6.0369v0.2115c0 0.1976-0.0415 0.3374-0.126 0.4223-0.0838 0.1405-0.196 0.2107-0.3358 0.2107-0.1122 0-0.2804-0.0556-0.5048-0.169l-5.3782-2.8286-5.3782 2.8286c-0.2243 0.1134-0.3918 0.169-0.504 0.169-0.1683 0-0.2943-0.0702-0.378-0.2107-0.0838-0.0849-0.126-0.2247-0.126-0.4223 0-0.0849 0.0138-0.1544 0.0422-0.2115l1.0081-6.0369-4.3694-4.2636c-0.196-0.3096-0.2943-0.5072-0.2943-0.5914 0-0.3087 0.2243-0.4925 0.6723-0.5488l6.0505-0.8863 2.6891-5.4887c0.1674-0.3374 0.3634-0.5064 0.5877-0.5064 0.2244 0 0.4203 0.169 0.5885 0.5064l2.6891 5.4887 6.0505 0.8863c0.448 0.0563 0.6723 0.2401 0.6723 0.5488z", clipRule: "evenodd", fill: "#001246", fillRule: "evenodd" })), So = /* @__PURE__ */ f("div", {
  target: "efitneq14"
})("position:relative;inline-size:300px;min-block-size:449px;margin:auto;padding-block:16px;padding-inline:24px;background-color:#f1ecdc;", _.breakpoints.up("tablet"), "{inline-size:600px;max-inline-size:600px;min-block-size:407px;}"), Io = /* @__PURE__ */ f("div", {
  target: "efitneq13"
})("display:flex;flex-flow:column;justify-content:center;align-items:center;#sa-login-widget{inline-size:100%;", _.breakpoints.up("tablet"), "{max-inline-size:252px;}}.sa-google-login-button{margin-block-end:0;}.sa-login-widget{inline-size:100%;}"), qo = /* @__PURE__ */ f("div", {
  target: "efitneq12"
})("max-inline-size:252px;margin-block:16px 0;color:#001246;font-weight:900;font-size:16px;font-family:", B, ";line-height:20px;text-align:center;", _.breakpoints.up("tablet"), "{max-inline-size:480px;margin-block:16px 0;font-weight:900;font-size:24px;font-family:", B, ";line-height:30.17px;}"), To = /* @__PURE__ */ f(wo, {
  target: "efitneq11"
})({
  name: "19niaop",
  styles: "inline-size:33px;block-size:25px"
}), Ro = /* @__PURE__ */ f("div", {
  target: "efitneq10"
})({
  name: "37aeay",
  styles: "display:flex;flex-flow:row;justify-content:center;align-items:center;margin-block:16px 0"
}), zo = /* @__PURE__ */ f(bo, {
  target: "efitneq9"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Lo = /* @__PURE__ */ f(xo, {
  target: "efitneq8"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Eo = /* @__PURE__ */ f(Co, {
  target: "efitneq7"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Oo = /* @__PURE__ */ f(ko, {
  target: "efitneq6"
})({
  name: "8q934",
  styles: "inline-size:40px;block-size:40px;margin-inline:4px"
}), Po = /* @__PURE__ */ f("div", {
  target: "efitneq5"
})("max-inline-size:360px;margin-block:16px 0;margin-inline:6px 0;", _.breakpoints.up("tablet"), "{margin-block:16px 0;margin-inline:0;}"), No = /* @__PURE__ */ f("div", {
  target: "efitneq4"
})("display:flex;flex-flow:row;justify-content:flex-start;align-items:flex-start;padding-block:0 8px;color:#001246;font-size:14px;font-family:", z, ";line-height:130%;&:last-of-type{padding:0;}", _.breakpoints.up("tablet"), "{font-size:16px;font-family:", z, ";}"), Ao = /* @__PURE__ */ f("div", {
  target: "efitneq3"
})({
  name: "823mde",
  styles: "margin-inline:0 7px"
}), Fo = /* @__PURE__ */ f("span", {
  target: "efitneq2"
})(""), Mo = /* @__PURE__ */ f("div", {
  target: "efitneq1"
})({
  name: "hsrr3n",
  styles: "inline-size:100%;margin-block:16px 0;.sa-login-widget-title{display:none;}"
}), jo = /* @__PURE__ */ f("div", {
  target: "efitneq0"
})("margin-block:16px 0;color:#4585ff;font-size:14px;font-family:", z, ";cursor:pointer;border-block-end:1px #4585ff solid;"), Nt = ({
  modalContainerReference: e,
  onClose: t,
  whyRegister: n
}) => {
  const r = n.content.introductions, i = Object.keys(r).sort((u, v) => u.localeCompare(v)), {
    config: a,
    handleOpenLoginDialog: o,
    handleTrackGA4: s
  } = R(), l = P(() => _o(n.trackingActionName), [n.trackingActionName]), p = q((u) => {
    if (!u) return;
    const v = new URL(a.accounts.host);
    Gt.init({
      AUTH_CALLBACK_URL: `${a.accounts.authCallbackUrl}`,
      DEBUG_LOG: !1,
      DESTINATION: l,
      RECAPTCHA_CONTAINER_ID: "",
      RECAPTCHA_SITE_KEY: `${a.recaptcha.siteKey}`,
      REGISTER_CALLBACK_URL: `${a.accounts.registerCallbackUrl}`,
      SCMP_ACCOUNT_HOST: v.host,
      SCMP_ACCOUNT_PROTOCOL: v.protocol.slice(0, -1)
    });
    const h = Hr();
    Gt.initLoginWidget(u.id, {
      destination: l,
      loginDescription: "",
      loginWithEmail: !1,
      sendWelcomeEmail: !1,
      thirdPartySignInOptions: {
        triggerPoint: "ppto",
        withGoogle: !h
      },
      title: ""
    });
  }, [a.accounts.authCallbackUrl, a.accounts.host, a.accounts.registerCallbackUrl, a.recaptcha.siteKey, l]), d = n.trackingActionName;
  W(() => {
    s({
      action: "imp",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: d,
        step: "1"
      },
      subcategory: ""
    });
  });
  const b = () => {
    s({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: d,
        message: "Sign in with Google",
        step: "1"
      },
      subcategory: ""
    });
  }, g = () => {
    s({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: d,
        message: "Sign in with other methods",
        step: "1"
      },
      subcategory: ""
    }), t(), o({
      destination: l,
      ga4CustomParameter: {
        internal_campaign: d,
        trigger_point: "ppto"
      }
    });
  }, m = () => {
    s({
      action: "click",
      category: "promopopup",
      customized_parameters: {
        cta_type: "login_register",
        internal_campaign: d,
        message: "close button",
        step: "1"
      },
      subcategory: ""
    }), t();
  };
  return /* @__PURE__ */ c.createElement($, {
    BackdropComponent: Y,
    container: e == null ? void 0 : e.current,
    fadeTimeout: 400,
    open: !0,
    "data-qa": "why-register-popup"
  }, /* @__PURE__ */ c.createElement(So, null, /* @__PURE__ */ c.createElement(H, {
    onClose: m
  }), /* @__PURE__ */ c.createElement(Io, null, /* @__PURE__ */ c.createElement(To, null), /* @__PURE__ */ c.createElement(qo, {
    dangerouslySetInnerHTML: {
      __html: n.content.title
    }
  }), /* @__PURE__ */ c.createElement(Ro, null, /* @__PURE__ */ c.createElement(Eo, null), /* @__PURE__ */ c.createElement(zo, null), /* @__PURE__ */ c.createElement(Lo, null), /* @__PURE__ */ c.createElement(Oo, null)), /* @__PURE__ */ c.createElement(Po, null, i.map((u) => /* @__PURE__ */ c.createElement(No, {
    key: u
  }, /* @__PURE__ */ c.createElement(Ao, null, `${u}. `), /* @__PURE__ */ c.createElement(Fo, {
    dangerouslySetInnerHTML: {
      __html: r[u]
    }
  })))), /* @__PURE__ */ c.createElement(Mo, {
    id: "social-login-widget",
    onClick: b,
    ref: p
  }), /* @__PURE__ */ c.createElement(jo, {
    onClick: g
  }, "Sign in with other methods"))));
};
Nt.displayName = "WhyRegisterPopup";
const Do = ["action"], Ho = (e) => {
  const {
    acquisition: {
      popupState: t
    },
    currentRoute: n,
    handleRemoveRouteQuery: r,
    hasWhyRegisterPPTOHomepagePositionIntersected: i,
    userCountry: a,
    userTypeIds: o
  } = R(), s = q(() => {
    vo(new URL(n, globalThis.location.origin).search) && r(Do);
  }, [n, r]), l = ae(_.breakpoints.only("mobile"), !1), p = q((g) => {
    var m;
    const u = Object.values(t.whyRegister).find((h) => !h.positioningTrigger && Q({
      config: h,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: a ?? "",
        userDevice: l ? "mobile" : "desktop",
        userTypeIds: o
      }
    }));
    if (!u) return;
    const v = {
      modalContainerReference: e.modalContainerReference,
      onClose: g,
      whyRegister: u
    };
    return {
      delay: Number.parseInt((m = u.timeout) !== null && m !== void 0 ? m : "0", 10),
      element: /* @__PURE__ */ c.createElement(Nt, v),
      localStorageKey: u.localStorageKey,
      updateLocalStorageOnShow: !0
    };
  }, [l, e.isLoggedIn, e.modalContainerReference, t.whyRegister, a, o]), d = q((g) => {
    var m;
    const u = Object.values(t.whyRegister).find((h) => h.positioningTrigger && Q({
      config: h,
      userInfo: {
        isLoggedIn: e.isLoggedIn,
        userCountry: a ?? "",
        userDevice: l ? "mobile" : "desktop",
        userTypeIds: o
      }
    }));
    if (!u || !i) return;
    const v = {
      modalContainerReference: e.modalContainerReference,
      onClose: g,
      whyRegister: u
    };
    return {
      delay: Number.parseInt((m = u.timeout) !== null && m !== void 0 ? m : "0", 10),
      element: /* @__PURE__ */ c.createElement(Nt, v),
      localStorageKey: u.localStorageKey,
      updateLocalStorageOnShow: !0
    };
  }, [i, l, e.isLoggedIn, e.modalContainerReference, t.whyRegister, a, o]);
  return P(() => ({
    getNextFromAction: s,
    getNextFromConfig: p,
    getNextFromScrollPosition: d
  }), [s, p, d]);
}, kr = ({
  configEnvironmentSlug: e,
  queryReference: t,
  ...n
}) => {
  var r;
  const {
    currentRouteWithoutQuerystring: i
  } = R(), a = Er(Sr, t);
  ma({}, a), F(() => {
    i && Nr("event", "optimize.triggerCampaign");
  }, [i]);
  const o = Bi(n), s = Mi(n), l = Ho(n), p = yo(n), d = eo(n), b = P(() => ({
    [G.AcquisitionNewsletter]: s,
    [G.Campaign]: o,
    [G.MyNewsCompletion]: d,
    [G.TopicPackageFollow]: p,
    [G.WhyRegister]: l
  }), [s, o, d, p, l]), {
    popup: g
  } = Ii(b, n);
  return (r = g == null ? void 0 : g.element) !== null && r !== void 0 ? r : null;
};
kr.displayName = "AcquisitionPopupContainerDisplay";
const Sr = sr;
function At() {
  return At = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, At.apply(null, arguments);
}
const $o = (e) => {
  const [t, n, r] = Or(Sr);
  return F(() => (n({}), r), [n, r]), /* @__PURE__ */ c.createElement(zr, {
    "data-qa": "acquisition-popup-container"
  }, t && /* @__PURE__ */ c.createElement(kr, At({}, e, {
    queryReference: t
  })));
};
$o.displayName = "AcquisitionPopupContainer";
export {
  $o as A,
  dr as B,
  fr as C,
  si as D,
  $i as F,
  $ as M,
  Ht as R,
  Xa as a,
  ti as b,
  ur as c,
  ei as d,
  ni as e,
  _a as f,
  le as g,
  fi as h,
  Dt as i,
  pr as j,
  pi as k,
  mi as l,
  ss as m,
  Fa as n,
  Ma as o,
  Ua as p,
  Ft as q,
  Wa as r,
  Hi as s,
  Ea as t,
  ua as u,
  di as v,
  ha as w,
  gi as x,
  Mt as y,
  wa as z
};
//# sourceMappingURL=component-D9a2zlDY.mjs.map
